var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53333 7.46667H12.2667C12.5612 7.46667 12.8 7.70545 12.8 8C12.8 8.29455 12.5612 8.53333 12.2667 8.53333H8.53333V12.2667C8.53333 12.5612 8.29455 12.8 8 12.8C7.70545 12.8 7.46667 12.5612 7.46667 12.2667V8.53333H3.73333C3.43878 8.53333 3.2 8.29455 3.2 8C3.2 7.70545 3.43878 7.46667 3.73333 7.46667H7.46667V3.73333C7.46667 3.43878 7.70545 3.2 8 3.2C8.29455 3.2 8.53333 3.43878 8.53333 3.73333V7.46667ZM8 0C12.4113 0 16 3.58871 16 8C16 12.4113 12.4113 16 8 16C3.58871 16 0 12.4113 0 8C0 3.58871 3.58871 0 8 0ZM8 0.941177C4.10165 0.941177 0.941177 4.10165 0.941177 8C0.941177 11.8984 4.10165 15.0588 8 15.0588C11.8984 15.0588 15.0588 11.8984 15.0588 8C15.0588 4.10165 11.8984 0.941177 8 0.941177Z",
    fill: "#292929"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.b0e4eb848885351ebd47a1f38cdc1b98.svg";
export { ForwardRef as ReactComponent };